import messages from "../../locale/messages";

const validate = values => {

    const errors = {}

    if (!values?.walletBalance || values?.walletBalance.trim() == "") {
        errors.walletBalance = messages.walletAmountRequired;
    } else if ((values?.walletBalance && isNaN(values?.walletBalance)) || values?.walletBalance == 0) {
        errors.walletBalance = messages.invalidWalletAmount;
    }

    return errors
}

export default validate;